/**
 * The error thrown when trying to use children other than <Option>.
 * @type {String}
 */
export const OPTION_CHILD_ERROR = 'Only <Select.Option> components are valid children of <Select>';
